module.exports = __webpack_public_path__ + "media/media/product-card/_vlsat_plus_empty-4b976f35b3ca6d9d3668da0cc4cee39d.jpg";